import Swiper from 'swiper'
import {Slideshow} from './class/Slideshow'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
export default function index(){

  const slides = document.getElementById('indexSlides')
  let slideInterval
  if(slides){
    const slideshow = new Slideshow(slides)
    let slideIndex = 0
    slideInterval = setInterval(()=> {
      slidesEvent(true, false)
    },5000)
    document.querySelector('.firstview__nav__item--prev').addEventListener('click', () => 
      slidesEvent(false)
    )
    document.querySelector('.firstview__nav__item--next').addEventListener('click', () => 
      slidesEvent(true)
    )

    function slidesEvent(bool = true, clear = true){
      document.querySelectorAll('.firstview__nav__item').forEach((el) => {
        el.classList.add('disabled')
      })
      setTimeout(()=>{
        document.querySelectorAll('.firstview__nav__item').forEach((el) => {
          el.classList.remove('disabled')
        })
      },2000)

      if(bool){
        slideIndex ++
        slideshow.next()
      }else{
        slideIndex --
        slideshow.prev()
      }

      if(slideIndex > slideshow.slidesTotal -1){
        slideIndex = 0;
      }else if(slideIndex < 0){
        slideIndex = slideshow.slidesTotal -1
      }
      const element = document.querySelector('.firstview__catch')
      const regex = /^color-\d+$/;
      [...element.classList].forEach(className => {
        if (regex.test(className)) {
          element.classList.remove(className)
        }
      })
      element.classList.add(`color-${slideIndex}`)


      if(clear){
        clearInterval(slideInterval)
      }
    }
  }

  // 横スクロール
  const scrollSlides = document.querySelectorAll('.site-index .horizontal__item').length
  const scrollSlideHeight = scrollSlides * 200
  const scrollBeforeEl = document.querySelector('.horizontal-before-el')

  if(scrollSlides > 0){
    ScrollTrigger.create({
      trigger: ".site-index .business",
      start: "top top",
      end: `+=${scrollSlideHeight + 100}%`,
      pin: true,
      //markers: true
    })
  
    gsap.fromTo('.site-index .business .horizontal',
      {},
      {
        left: `-${scrollSlideHeight / 4}%`,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: scrollBeforeEl,
          start: "bottom -50%",
          end: `+=${scrollSlideHeight}%`,
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }
}